import {Component} from '@angular/core';
import {ApiService} from './../../services/api.service';
import {FloatButtonCartService} from './../../components/floatButtonCart/floatButtonCart.service';
import * as _ from "lodash";


@Component({
  selector: 'my-cart',
  template: require('./cart.component.html'),
  styles: [require('./cart.component.scss')]
})
export class CartComponent {

  public listProductos = [];
  public total: number = 0;
  public pais = JSON.parse(localStorage.getItem('pais'));
  public controlPay: any = false;
  public typeUser: number = 1;

//  subscription: Subscription;

  constructor(private _api: ApiService, private _floatservice: FloatButtonCartService) {
    if(localStorage.getItem('login')){
      this.controlPay = true;
      let user = JSON.parse(localStorage.getItem('login'));
      if(user.tipoUsuario == 'cliente'){
        this.typeUser = user.tipoCliente;
      }
    }
    if (localStorage.getItem('carrito')) {
      let obj: any = JSON.parse(localStorage.getItem('carrito'));
      let array = [];
      for (let index in obj) {
        array.push(index);
      }
      this._api.getProductoMulti(array).subscribe(
        result => {
          this.listProductos = result;
          for (let producto in this.listProductos) {
            this.listProductos[producto].cantidad = obj[this.listProductos[producto].idProducto];
            let precio = 0;
            switch (this.typeUser) {
              case 2:
                precio = this.listProductos[producto].precioNormal;
                break;
              case 3:
                precio = this.listProductos[producto].precioVip;
                break;
              default:
                precio = this.listProductos[producto].precioEventual;
                break;
            }
            this.total = this.total + (this.listProductos[producto].cantidad * precio);
          }
        }
      );
    }
  }

  public updateTotal(): void {
    this.total = 0;
    for (let producto in this.listProductos) {
      let precio = 0;
      switch (this.typeUser) {
        case 2:
          precio = this.listProductos[producto].precioNormal;
          break;
        case 3:
          precio = this.listProductos[producto].precioVip;
          break;
        default:
          precio = this.listProductos[producto].precioEventual;
          break;
      }
      this.total = this.total + (this.listProductos[producto].cantidad * precio)
    }
  }

  public add(producto) {
    producto.cantidad = parseInt(producto.cantidad) + 1;
    this._floatservice.remplaceToCart(producto.idProducto, producto.cantidad, false);
    this.updateTotal();
  }

  public sub(producto) {
    if (producto.cantidad > 1) {
      producto.cantidad = parseInt(producto.cantidad) - 1;
      this._floatservice.remplaceToCart(producto.idProducto, producto.cantidad, false);
      this.updateTotal();
    }
  }

  public change(producto) {
    if (producto.cantidad <= 0) {
      producto.cantidad = 1;
    }
    if ((producto.cantidad % 1) > 0) {
      producto.cantidad = producto.cantidad - (producto.cantidad % 1);
    }
    this._floatservice.remplaceToCart(producto.idProducto, producto.cantidad, false);
    this.updateTotal();
  }

  public delete(producto) {
    _.remove(this.listProductos, {idProducto: producto.idProducto});
    this._floatservice.deleteToCart(producto.idProducto);
    this.updateTotal();
  }


}
/**
 * Created by Desarrollo KJ on 20/3/2017.
 */



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/cart/cart.component.ts